import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FormResponse } from '../../../lib';
import { Kfi } from '../models/kfi.model';
import { KfiService } from './kfi.service';

@Injectable()
export abstract class KfiFormService {
  constructor(protected readonly kfiService: KfiService) {}

  initializeKfiApplication(kfiId: string): Observable<FormResponse<Kfi>> {
    return this.kfiService.loadKfi(kfiId);
  }

  initializeLoanTypes(mortgageApplication: Kfi): Observable<any> {
    return this.kfiService.loadAvailableLoanTypes(mortgageApplication);
  }

  abstract initialize(kfiId: string): Observable<FormResponse<Kfi>>;
}
